import {
  aniSlideYIn,
  aniSlideYOut,
  aniFlipIn,
  aniFlipOut,
  aniFadeIn,
  aniFadeOut,
} from '../js/Transitions.js';

export const transitions = {
  methods: {
    slideYIn(el, done) {
      let animation = aniSlideYIn(el, el.clientHeight, 1000);
      animation.finished.then(() => {
        done();
      });
    },

    slideYOut(el, done) {
      let animation = aniSlideYOut(el, el.clientHeight * -1, 1000);
      animation.finished.then(() => {
        done();
      });
    },

    flipIn(el, done) {
      let animation = aniFlipIn(el, 400);
      animation.finished.then(() => {
        done();
      });
    },

    flipOut(el, done) {
      let animation = aniFlipOut(el, 400);
      animation.finished.then(() => {
        done();
      });
    },

    fadeIn(el, done) {
      let animation = aniFadeIn(el, 1000);
      animation.finished.then(() => {
        done();
      });
    },

    fadeOut(el, done) {
      let animation = aniFadeOut(el, 1000);
      animation.finished.then(() => {
        done();
      });
    },
  },
};
